/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Community_EyebrowInputs */

const en_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const es_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidad`)
};

const de_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeinschaft`)
};

const zh_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区`)
};

const ar_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجتمع`)
};

const fr_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communauté`)
};

const vi_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cộng đồng`)
};

const sw_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumuiya`)
};

const th_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชุมชน`)
};

const bs_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajednica`)
};

const ja_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミュニティ`)
};

const ko_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커뮤니티`)
};

const pt_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidade`)
};

const it_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunità`)
};

const sv_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemenskap`)
};

const nl_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeenschap`)
};

const da_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fællesskab`)
};

const nb_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fellesskap`)
};

const fi_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteisö`)
};

const pl_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Społeczność`)
};

const ru_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщество`)
};

const tr_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topluluk`)
};

const hi_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समुदाय`)
};

const id_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas`)
};

const ms_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komuniti`)
};

const cs_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunita`)
};

const el_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κοινότητα`)
};

const he_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קהילה`)
};

const af_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeenskap`)
};

const hu_range_community_eyebrow = /** @type {(inputs: Range_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közösség`)
};

/**
* | output |
* | --- |
* | "Community" |
*
* @param {Range_Community_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_community_eyebrow = /** @type {((inputs?: Range_Community_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Community_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_community_eyebrow(inputs)
	if (locale === "de") return de_range_community_eyebrow(inputs)
	if (locale === "zh") return zh_range_community_eyebrow(inputs)
	if (locale === "ar") return ar_range_community_eyebrow(inputs)
	if (locale === "fr") return fr_range_community_eyebrow(inputs)
	if (locale === "vi") return vi_range_community_eyebrow(inputs)
	if (locale === "sw") return sw_range_community_eyebrow(inputs)
	if (locale === "th") return th_range_community_eyebrow(inputs)
	if (locale === "bs") return bs_range_community_eyebrow(inputs)
	if (locale === "ja") return ja_range_community_eyebrow(inputs)
	if (locale === "ko") return ko_range_community_eyebrow(inputs)
	if (locale === "pt") return pt_range_community_eyebrow(inputs)
	if (locale === "it") return it_range_community_eyebrow(inputs)
	if (locale === "sv") return sv_range_community_eyebrow(inputs)
	if (locale === "nl") return nl_range_community_eyebrow(inputs)
	if (locale === "da") return da_range_community_eyebrow(inputs)
	if (locale === "nb") return nb_range_community_eyebrow(inputs)
	if (locale === "fi") return fi_range_community_eyebrow(inputs)
	if (locale === "pl") return pl_range_community_eyebrow(inputs)
	if (locale === "ru") return ru_range_community_eyebrow(inputs)
	if (locale === "tr") return tr_range_community_eyebrow(inputs)
	if (locale === "hi") return hi_range_community_eyebrow(inputs)
	if (locale === "id") return id_range_community_eyebrow(inputs)
	if (locale === "ms") return ms_range_community_eyebrow(inputs)
	if (locale === "cs") return cs_range_community_eyebrow(inputs)
	if (locale === "el") return el_range_community_eyebrow(inputs)
	if (locale === "he") return he_range_community_eyebrow(inputs)
	if (locale === "af") return af_range_community_eyebrow(inputs)
	if (locale === "hu") return hu_range_community_eyebrow(inputs)
	return en_range_community_eyebrow(inputs)
});